import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'chevron', 'content'];

  initialize() {
    this.toggle = this.toggle.bind(this);
    this.expand = this.expand.bind(this);
    this.collapse = this.collapse.bind(this);
  }

  connect() {
    this.buttonTarget.addEventListener('click', this.toggle);
  }

  disconnect() {
    this.buttonTarget.removeEventListener('click', this.toggle);
  }

  toggle() {
    const isCollapsed = this.contentTarget.classList.contains('max-h-0');

    if (isCollapsed) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  expand() {
    this.contentTarget.classList.remove('max-h-0', 'opacity-0');
    this.contentTarget.classList.add('max-h-96', 'opacity-100');
  }

  collapse() {
    this.contentTarget.classList.remove('max-h-96', 'opacity-100');
    this.contentTarget.classList.add('max-h-0', 'opacity-0');
  }
}